<template>
    <div :key="tick+'oacert'" class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Oasis Zertifikate
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button type="primary" size="sm" v-on:click="$router.push('/oasiscerts/create')" icon="ni ni-fat-add"></base-button>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>id</th>
                    <TableHeadFilter v-if="isAdmin" title="Organisation" v-model="tableOptions.filter.customer" :has-filter="true" filter-type="dropdown" :dropdown-list="customers" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Bezeichnung" v-model="tableOptions.filter.name" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <th>Gültig von</th>
                    <th>Gültig bis</th>
                    <th></th>
                </template>

                <template slot-scope="{row,index}">
                    <th scope="row">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td v-if="isAdmin">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{(typeof row.customer !== 'undefined') ? row.customer.name : '#ERR'}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.name}}<br><span class="text-muted small">({{row.privateCertNickname}})</span></div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else><span v-if="(typeof row.privateCertValidDates !== 'undefined')">{{ row.privateCertValidDates.from | formatDateToDay }}</span>
                        <span v-else>#Error: Problem mit Zertifikat</span></div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else><span v-if="(typeof row.privateCertValidDates !== 'undefined')">{{ row.privateCertValidDates.to | formatDateToDay }}</span>
                        <span v-else>#Error: Problem mit Zertifikat</span></div>
                    </td>
                    <td class="text-right">
                        <div v-if="isLoading" class="loading-button"> </div><div v-else> <template>
                                <base-button v-on:click="$router.push('/oasiscerts/edit/'+row.id)" icon="fas fa-eye" type="primary" icon-only
                                              title="Ansehen und bearbeiten"></base-button>
                        <base-button v-if="!row.delete" type="secondary" icon="far fa-trash-alt" icon-only v-on:click="deleteConfirmation(index)"></base-button>
                        <div v-if="row.delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="far fa-trash-alt"></i></span><br>
                            <base-button :key="tick+'ncb2'" v-if="row.delete" size="sm" :disabled="currentlyLoading.includes(row.id)" :icon="(currentlyLoading.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'fas fa-check'" type="danger" v-on:click="deleteIT(row)">Ja</base-button>
                            <base-button v-if="row.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                        </div>
                            </template></div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    import TableHeadFilter from "@/components/TableHeadFilter";
    export default {
        name: "list",
        components:{TableHeadFilter},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                tableOptions: {
                    filter: {
                        name: null,
                        customer: null,
                    },
                    dateFilter: {
                    },
                    sort:{
                    }},
                tableData: [
                    {
                        id: 0,
                        name: "",
                        privateCertValidDates: {
                          from: '',
                          to: ''
                        },
                        privateCertNickname: '',
                        customer: {
                            name: null
                        }
                    }
                ],
                totalitems: 0,
                page: 1,
                isLoading: false,
                tick: 1516541,
                currentlyLoading: [],
            }
        },
        created() {
          this.changePage(this.page);
          if (!this.$store.getters['country/isReady']) this.$store.dispatch('country/getCountryCollection');
            if (!this.$store.getters['customer/isReady']) this.$store.dispatch('customer/getCustomerCollection');
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            customers() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['customer/isReady']) ? [] : this.$store.getters['customer/showCustomerCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            }
        },
        methods: {
            deleteConfirmation(index) {
                if(typeof this.tableData[index].delete === "undefined") {
                    this.tableData[index].delete = false;
                }
                this.tableData[index].delete = !this.tableData[index].delete;
                this.tick++;
            },
            deleteIT(data) {
                return new Promise((resolve, reject) => {
                    this.currentlyLoading.push(data.id);
                    data.delete = false;
                    this.tick++;
                    //this.deleteConfirmation(this.tableData.indexOf(data));
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'DELETE',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/oasis_certs/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.$store.dispatch('alert/success','Zertifikat erfolgreich gelöscht.');
                                this.changePage(this.page);
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            },
                            error => {
                                reject(error);
                                this.$store.dispatch('alert/error','Zertifikat konnte nicht gelöscht werden. Möglicherweise wird das Zertifikat noch an einem Standort verwendet.');
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            });
                });
            },
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/oasis_certs?`+ this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter) +`page=` + page, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

<style scoped>

</style>